import { Injectable } from '@angular/core';
import { WiseIdAuthServiceManager } from '../features/sso-wise-id/controller/wise-id-auth.service-manager';
import { UserProfileData } from '@solverml/api';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  private currentUser: UserProfileData | null;

  constructor(private authService: WiseIdAuthServiceManager) {
    this.currentUser = this.authService.getUserProfileSessionData();
  }

  /**
   * Comprueba si el usuario tiene permiso para ver la sección de Análisis.
   */
  public canReadAnalysis(): boolean {
    return this.currentUser?.permission_access?.canReadAnalysis || false;
  }

  /**
   * Comprueba si el usuario tiene permiso para ver la sección de Rendimiento.
   */
  public canReadPerformance(): boolean {
    return this.currentUser?.permission_access?.canReadPerformance || false;
  }

  /**
   * Comprueba si el usuario tiene permiso para ver la sección de Salud.
   */
  public canReadHealth(): boolean {
    return this.currentUser?.permission_access?.canReadHealth || false;
  }

  /**
   * Comprueba si el usuario tiene permiso para subir vídeos.
   */
  public canUploadVideo(): boolean {
    return this.currentUser?.permission_access?.canUploadVideo || false;
  }


  /**
   * Comprueba si el usuario es Administrador.
   */
  public isAdmin(): boolean {
    return this.currentUser?.permission_access?.isAdmin || false;
  }
}
